import fetchTBTSignings from '../Services/fetchTBTSignings'

export default (pagination, filters, sorter) => (dispatch, getState) => {
  const { searchTerm } = getState().screens.TBTSigning
  
  dispatch(fetchTBTSignings({
    search: searchTerm,
    filters,
    page: pagination.current,
    per_page: pagination.pageSize,
    sort_field: sorter.field,
    sort_order: sorter.order,
  }))
}
